export { default } from './index.vue';



// WEBPACK FOOTER //
// ./packages/dof-part-loading/index.js